import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'laser',
  size: 24,
  node: [
    ['path', { d: 'm13 8 .95-.95', key: '1w28a0' }],
    ['path', { d: 'M13.95 16.95 13 16', key: '1aw54t' }],
    ['path', { d: 'M22 12h-9', key: '1wq8hv' }],
    ['path', { d: 'M4 12H2', key: 'rhcxmi' }],
    ['path', { d: 'M4.05 16.95 5 16', key: '1f9uwk' }],
    ['path', { d: 'm5 8-.95-.95', key: '1to6i7' }],
    ['path', { d: 'M9 12h.01', key: '157uk2' }],
    ['path', { d: 'M9 19v-2', key: 'anqm27' }],
    ['path', { d: 'M9 7V5', key: 'q7fpoa' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Laser
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTMgOCAuOTUtLjk1IiAvPgogIDxwYXRoIGQ9Ik0xMy45NSAxNi45NSAxMyAxNiIgLz4KICA8cGF0aCBkPSJNMjIgMTJoLTkiIC8+CiAgPHBhdGggZD0iTTQgMTJIMiIgLz4KICA8cGF0aCBkPSJNNC4wNSAxNi45NSA1IDE2IiAvPgogIDxwYXRoIGQ9Im01IDgtLjk1LS45NSIgLz4KICA8cGF0aCBkPSJNOSAxMmguMDEiIC8+CiAgPHBhdGggZD0iTTkgMTl2LTIiIC8+CiAgPHBhdGggZD0iTTkgN1Y1IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/laser
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Laser = createLucideIcon(__iconData);

export default Laser;
